"use strict";

var _createForOfIteratorHelper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LongFontFamilyPropertyValidator = void 0;
var _LongCSSPropertyValidator = require("./LongCSSPropertyValidator");
var _normalizeFontName = _interopRequireDefault(require("./normalizeFontName"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SEPARATOR_REGEX = /,\s*/;
var LongFontFamilyPropertyValidator = /*#__PURE__*/function (_LongCSSPropertyValid) {
  _inherits(LongFontFamilyPropertyValidator, _LongCSSPropertyValid);
  var _super = _createSuper(LongFontFamilyPropertyValidator);
  function LongFontFamilyPropertyValidator() {
    _classCallCheck(this, LongFontFamilyPropertyValidator);
    return _super.apply(this, arguments);
  }
  _createClass(LongFontFamilyPropertyValidator, [{
    key: "normalizeRawInlineCSSValue",
    value: function normalizeRawInlineCSSValue(value) {
      var values = value.split(SEPARATOR_REGEX);
      var _iterator = _createForOfIteratorHelper(values),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var font = _step.value;
          var normalizedFont = (0, _normalizeFontName.default)(font);
          var isFontSupported = normalizedFont.length && this.config.isFontSupported(normalizedFont);
          if (isFontSupported) {
            return typeof isFontSupported === 'string' ? isFontSupported : normalizedFont;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "normalizeNativeValue",
    value: function normalizeNativeValue(value) {
      return this.normalizeInlineCSSValue(value);
    }
  }]);
  return LongFontFamilyPropertyValidator;
}(_LongCSSPropertyValidator.LongCSSPropertyValidator);
exports.LongFontFamilyPropertyValidator = LongFontFamilyPropertyValidator;